angular.module("ainapp")
    .controller("realestateDashController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
                function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {


            $scope.PageName = "Realestate Dashboard";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }



            $scope.BuildingChartFun = function () {

                $("#buildingchart").kendoChart({
                    title: {
                        text: $scope.LanguageData.BuildingUnitOverview
                    },
                    legend: {
                        visible: false
                    },
                    series: $scope.buildingchartData.series,
                    valueAxis: {
                        line: {
                            visible: false
                        },
                        minorGridLines: {
                            visible: true
                        },
                        labels: {
                            rotation: "auto"
                        }
                    },
                    categoryAxis: {
                        categories: $scope.buildingchartData.categories,
                        majorGridLines: {
                            visible: false
                        }
                    },
                    tooltip: {
                        visible: true,
                        template: "#= series.name #: #= value #"
                    }
                });

            }

            $scope.MostSellingUnitDataFun = function () {

                $("#mostSellingUnitchart").kendoChart({
                    title: {
                        text: $scope.LanguageData.MostSellingUnitTypes
                    },
                    legend: {
                        visible: false
                    },
                    seriesDefaults: {
                        type: "bar"
                    },
                    series: $scope.MostSellingUnitData.series,
                    valueAxis: {
                        line: {
                            visible: false
                        },
                        minorGridLines: {
                            visible: true
                        },
                        labels: {
                            rotation: "auto"
                        }
                    },
                    categoryAxis: {
                        categories: $scope.MostSellingUnitData.categories,
                        majorGridLines: {
                            visible: false
                        }
                    },
                    tooltip: {
                        visible: true,
                        template: "#= series.name #: #= value #"
                    }
                });

            }

            $scope.VacantUnitsChartFun = function () {

                $("#VacantUnitsChart").kendoChart({
                    title: {
                        position: "top",
                        text: $scope.LanguageData.VacantUnitsSummary
                    },
                    legend: {
                        visible: false
                    },
                    chartArea: {
                        background: ""
                    },
                    seriesDefaults: {
                        labels: {
                            visible: true,
                            background: "transparent",
                            template: "#= category #: \n #= value#"
                        }
                    },
                    series: [{
                        type: "pie",
                        startAngle: 150,
                        data: $scope.VacantUnits,
                                    }],
                    tooltip: {
                        visible: true,
                        format: "{0}"
                    }
                });
            }

            $scope.UsingUnitsChartFun = function () {

                $("#UsingUnitsChart").kendoChart({
                    title: {
                        position: "top",
                        text: $scope.LanguageData.ActiveUnitsSummary
                    },
                    legend: {
                        visible: false
                    },
                    chartArea: {
                        background: ""
                    },
                    seriesDefaults: {
                        type: "donut",
                        startAngle: 150
                    },
                    series: [{
                        name: "",
                        data: $scope.UsingUnits,
                                    }],
                    tooltip: {
                        visible: true,
                        template: "#= category # : #= value #%"
                    }
                });

            }


            $scope.Init = function () {

                $scope.dashcounts = [];
                MainService.RealestateDashCounts().then(function (response) {
                    $scope.dashcounts = response.data;
                }, function () {})

                $scope.EndingContracts = [];
                MainService.EndingContracts().then(function (response) {
                    $scope.EndingContracts = response.data;
                }, function () {})

                $scope.NewContracts = [];
                MainService.NewContracts().then(function (response) {
                    $scope.NewContracts = response.data;
                }, function () {})

                $scope.VacantFlats = [];
                MainService.VacantFlatsInHome().then(function (response) {
                    $scope.VacantFlats = response.data;
                }, function () {})

                $scope.buildingchartData = {};
                MainService.BuildingUnitsChart().then(function (response) {
                    $scope.buildingchartData = response.data;
                    if ($scope.buildingchartData != null) {
                        $scope.BuildingChartFun();
                    }
                }, function () {})

                $scope.MostSellingUnitData = {};
                MainService.MostSellingUnitTypes().then(function (response) {
                    $scope.MostSellingUnitData = response.data;
                    if ($scope.MostSellingUnitData != null) {
                        $scope.MostSellingUnitDataFun();
                    }
                }, function () {})

                $scope.VacantUnits = [];
                MainService.VacantUnitsChart().then(function (response) {
                    $scope.VacantUnits = response.data;
                    if ($scope.VacantUnits.length > 0) {
                        $scope.VacantUnitsChartFun();
                    }
                }, function () {})

                $scope.UsingUnits = [];
                MainService.UsingUnitsChart().then(function (response) {
                    $scope.UsingUnits = response.data;
                    if ($scope.UsingUnits.length > 0) {
                        $scope.UsingUnitsChartFun();
                    }
                }, function () {})


            }
            $scope.Init();


                        }])
